import _extends from 'babel-runtime/helpers/extends';

import { mapGetters } from 'vuex';
import SidebarItem from './SidebarItem';
import _variables from './variables.scss';

export default {
  components: { SidebarItem: SidebarItem },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    addOffset: {
      type: Number,
      default: 70
    },
    createButtonTitle: {
      type: String,
      default: ''
    },
    createButtonIcon: {
      type: String,
      default: 'el-icon-plus'
    },
    // 防止菜单被底部布局遮住
    paddingBottom: {
      type: String,
      default: '48px'
    }
  },
  data: function data() {
    return {
      buttonCollapse: false
    };
  },

  computed: _extends({}, mapGetters(['collapse']), {
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
          path = route.path,
          params = route.params;


      var title = this.WKConfig.companyName;
      if (meta.title) {
        title += ' - ' + meta.title;
      } else if (params && params.title) {
        title += ' - ' + params.title;
      }
      document.title = title;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    variables: function variables() {
      return _variables;
    }
  }),
  watch: {
    collapse: function collapse(val) {
      var _this = this;

      if (val) {
        this.buttonCollapse = val;
      } else {
        setTimeout(function () {
          _this.buttonCollapse = val;
        }, 300);
      }
    }
  },
  mounted: function mounted() {
    this.buttonCollapse = this.collapse;
  },

  methods: {
    toggleSideBarClick: function toggleSideBarClick() {
      this.$store.commit('SET_COLLAPSE', !this.collapse);
    },


    // 快速创建
    quicklyCreate: function quicklyCreate() {
      this.$emit('quicklyCreate');
    },
    handleSelect: function handleSelect(key, keyPath) {
      this.$emit('select', key, keyPath);
    }
  }
};